import { Card, List, Typography, Space, Tag } from 'antd';
import { DollarOutlined, CalendarOutlined, PercentageOutlined, LineChartOutlined, AppstoreOutlined, BankOutlined } from '@ant-design/icons';
import {stringMixin, money} from '../../../utils/strings'
const { Text } = Typography;

const EtfDetails = ({ etf }) => {
  const data = [
    { title: 'Issuer', value: etf?.specs.issuer },
    { title: 'Expense Ratio', value: stringMixin.pct(etf?.specs?.expense) },
    { title: 'AUM', value: money(etf?.specs?.aum) },
      {title: "Sector", child: <Tag>{etf?.tags?.sector}</Tag>},
      {title: "Industry", child: <Tag>{etf?.tags?.industry}</Tag>},
      {title: "Category", child: <Tag>{etf?.tags?.category}</Tag>},
      {title: "Exchange", value: etf?.tags?.exchange},

    // { title: 'Index Tracked', value: etfDetails.indexTracked, icon: <LineChartOutlined /> },
    // { title: 'Segment', value: etfDetails.segment, icon: <AppstoreOutlined /> },
    // { title: 'Structure', value: etfDetails.structure, icon: <BankOutlined /> },
  ];

  return (
    <Card title="SPY Summary Data" hoverable style={{ width: 400 }} bordered={false}>
      <List
        itemLayout="horizontal"
        dataSource={data}
        renderItem={(item) => (
          <List.Item>
            <Space style={{ width: '100%', justifyContent: 'space-between' }}>
              <Space>
                <Text>{item.title}</Text>
              </Space>
                {item.hasOwnProperty('child') ? item.child : <Text strong>{item?.value}</Text>}
            </Space>
          </List.Item>
        )}
      />
    </Card>
  );
};

export default EtfDetails;